import { render, staticRenderFns } from "./addDepartmentModal.vue?vue&type=template&id=79426de0&scoped=true&"
import script from "./addDepartmentModal.vue?vue&type=script&lang=js&"
export * from "./addDepartmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79426de0",
  null
  
)

export default component.exports